module.exports = __webpack_public_path__ + "media/dorobek/assets/images/logo-science2-5a1f9e3ce68b9cb4a7b97d2367248569.svg";